import { render, staticRenderFns } from "./DetailsCmp.vue?vue&type=template&id=4c235608&scoped=true"
import script from "./DetailsCmp.vue?vue&type=script&lang=js"
export * from "./DetailsCmp.vue?vue&type=script&lang=js"
import style0 from "./DetailsCmp.vue?vue&type=style&index=0&id=4c235608&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c235608",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre预发布-anjun-express-web-management/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c235608')) {
      api.createRecord('4c235608', component.options)
    } else {
      api.reload('4c235608', component.options)
    }
    module.hot.accept("./DetailsCmp.vue?vue&type=template&id=4c235608&scoped=true", function () {
      api.rerender('4c235608', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/finance/basicData/PriceInquiryLog/cmp/DetailsCmp.vue"
export default component.exports